import { useState } from "react";

export const useScrollDetectionV2 = <
  T extends HTMLElement = HTMLDivElement,
>() => {
  const [isScrolled, setIsScrolled] = useState(false);

  const ref = (node: T | null) => {
    if (!node) {
      return;
    }

    const handleScroll = () => setIsScrolled(node.scrollTop > 0);
    node.addEventListener("scroll", handleScroll);

    return () => node.removeEventListener("scroll", handleScroll);
  };

  return { isScrolled, ref };
};
